import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar1 } from './pages/Navbar1';
import { Aboutus } from './pages/Aboutus';
import { Contactus } from './pages/Contactus';
import { Home1 } from './pages/Home1';
import { PdfView } from './pages/PdfView';
import { Web3 } from './pages/Web3';
import Startup from './pages/Startup';
import Footer from './pages/Footer';
import { Ongingprojects1 } from './pages/Ongingprojects1';
import ScrollToTop from './pages/ScrollToTop';
import { MovieProduction } from './pages/MovieProduction';
import { Newproject } from './pages/Newproject';
import Scrolledtotop from './pages/Scrolledtotop';



function App() {
  return (
    <div className="App">

      <Router>
        <Scrolledtotop />
        <Navbar1 />
        <Routes>
          <Route path="/" element={<Home1 />} />
          <Route path="/about" element={<Aboutus />} />
          <Route path="/contact" element={<Contactus />} />
          <Route path="/pdfview" element={<PdfView />} />
          <Route path="/web3" element={<Web3 />} />
          <Route path="/ongoingprojects" element={<Startup />} />
          <Route path="/comingsoon" element={<Ongingprojects1 />} />
          <Route path="/moviepromotions" element={<MovieProduction />} />
          <Route path="/upcoming" element={<Newproject />} />
        </Routes>

        <Footer />
      </Router>

    </div>
  );
}

export default App;
